import "./LayerIdentifier.css";

import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";
import { CfSelect as ReactSelect } from "../CfSelect";
import { setLayerFilter } from "../../actions/resultMap";

export const LayerIdentifier = ({ transparent }) => {
  const [scope, { layer: selectedLayer }, distinctLayers] = useSelector(
    ({ resultMap }) => [
      resultMap.filteringProfile.scope,
      resultMap.filters,
      resultMap.distinctLayers,
    ]
  );

  const dispatch = useDispatch();
  const setSelectedLayer = (layer) => {
    dispatch(setLayerFilter(layer));
  };
  const layersOptions = distinctLayers.map((layer) => {
    return { label: layer, value: layer };
  });

  const styles = transparent
    ? {
        control: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: "transparent",
          borderColor: "#ffffff55",
        }),
        option: (provided, state) => ({
          ...provided,
          color: state.isSelected ? "white" : "black",
        }),
        singleValue: (provided) => ({ ...provided, color: "white" }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 1000,
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#ffffffbb",
        }),
        indicatorSeperator: (provided) => ({
          ...provided,
          color: "#ffffff55",
        }),
      }
    : {};

  return (
    distinctLayers.length > 0 && (
      <span className="layer-identifier">
        <i className="fa-solid fa-note-sticky discrete-icon" />
        {scope ? (
          scope.layer
        ) : (
          <ReactSelect
            className="flex-grow-1"
            styles={styles}
            menuPlacement="top"
            menuPortalTarget={document.querySelector("body")}
            value={{ label: selectedLayer, value: selectedLayer }}
            onChange={({ value }) => setSelectedLayer(value)}
            options={layersOptions}
          />
        )}
      </span>
    )
  );
};

LayerIdentifier.propTypes = {
  transparent: PropTypes.bool,
};
